'use client';
import React, { useEffect } from 'react';
import { mergeProps } from 'next-merge-props';

import { getServerSideIndexProps } from '../modules/page/getServerSideIndexProps';
import { getServerSideCookieProps } from '../modules/cookies/getServerSideCookieProps';

import { PageProps, usePageDataContext } from '../context/PageData';

import Page from '../components/Page';

export default function IndexPage(data: PageProps) {
  const {
    query: {
      utm_source = '',
      utm_medium,
      utm_campaign,
      utm_content,
      utm_term
    } = {},
    cookies: {
      gl_anonymous_id,
      gl_is_returning_user,
      gl_is_registered_user
    } = {}
  } = usePageDataContext();

  const [deviceType, setDeviceType] = React.useState<
    'mobile' | 'tablet' | 'desktop'
  >('desktop');

  useEffect(() => {
    const userAgent = navigator.userAgent.toLowerCase();

    if (/mobile/i.test(userAgent)) {
      setDeviceType('mobile');
    } else if (/tablet|ipad/i.test(userAgent)) {
      setDeviceType('tablet');
    }

    if (typeof window !== 'undefined' && window.optimizely) {
      window.optimizely.push({
        type: 'user',
        userId: gl_anonymous_id,
        attributes: {
          anonymousId: gl_anonymous_id,
          isWebsite: 'true',
          device: deviceType,
          firstSession: gl_is_returning_user === 'new',
          registeredUser: gl_is_registered_user === 'true',
          utmSource: utm_source,
          utmMedium: utm_medium,
          utmCampaign: utm_campaign,
          utmTerm: utm_term,
          utmContent: utm_content
        }
      });
    }
  }, []);

  return <Page key="homepage" {...data} />;
}

export const getServerSideProps = mergeProps([
  getServerSideIndexProps,
  getServerSideCookieProps
]);
